import { SPREAD_COLUMNS } from "src/documentList/types";
import actionCreatorFactory from "typescript-fsa";
import { SearchOptions } from "./types";

const create = actionCreatorFactory("SearchCache");

export const cacheSearch = create<SearchOptions>("CACHE_SEARCH");
export const deleteCachedSearch = create<{}>("DELETE_SEARCH_CACHE");
export const cacheSortColumn = create<SPREAD_COLUMNS>("UPDATE_SORT_COLUMN");



// WEBPACK FOOTER //
// ./src/searchCache/actions.ts